<nwm-menu />

<div class="row no-gutters">
  <div class="col-12">
    <router-outlet />
  </div>
</div>
